import { XINLI_SAND_MANIFEST } from '@/config/xinliSandManifest'
import { resolveStaticUrl } from '@/config/staticAssets'

const BOY_ANIM_TEX = resolveStaticUrl(
  '/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_tex_512.png'
)
const BOY_MESH_FBX = resolveStaticUrl('/static/models/boy.FBX')
/** boy.FBX 内嵌 .tga；FBXLoader 须同步读 TGA，加载后再换 boy_tex_512.png */
const BOY_MESH_TEX = resolveStaticUrl('/static/models/boy_tex.tga')
const GIRL_ANIM_TEX = resolveStaticUrl(
  '/static/models/心理沙盘模型/人物/女生-7个模型动画-1个贴图/Connie.png'
)
/** 女生 7 动作共用身体网格 girl.FBX（与 boy.FBX 同级，仅骨骼动画在 Connie_*.FBX） */
const GIRL_MESH_FBX = resolveStaticUrl('/static/models/girl.FBX')
const MAIN_RIG_FBX = '/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/_MainRig.fbx'

function isMainRigItem (item) {
  return (item.modelUrl || '').indexOf('各种人-共用贴图FBX/_MainRig.fbx') !== -1
}

/** 各种人共用 _MainRig.fbx 的 UV 色块图集（子目录 PNG 仅为预览，不能当贴图） */
const MAIN_RIG_ATLAS_TEX = resolveStaticUrl(
  MAIN_RIG_FBX.replace('_MainRig.fbx', 'color-atlas.png')
)

function resolveXinliTexture (item) {
  const url = item.modelUrl || ''
  if (url.indexOf('男孩-7个模型动画') !== -1) return BOY_ANIM_TEX
  if (url.indexOf('女生-7个模型动画') !== -1) return GIRL_ANIM_TEX
  if (url.indexOf('各种人-共用贴图FBX/_MainRig.fbx') !== -1) return MAIN_RIG_ATLAS_TEX
  if (url.indexOf('man-doctor.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/医生/color-atlas.png')
  if (url.indexOf('man-astronaut.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/宇航员/color-atlas.png')
  if (url.indexOf('man-basketball-player.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/医生/color-atlas.png')
  if (url.indexOf('man-fire.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/医生/color-atlas.png')
  if (url.indexOf('man-clown.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png')
  if (url.indexOf('man-chef.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png')
  if (url.indexOf('man-construction-worker.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png')
  if (url.indexOf('woman-doctor.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png')
  if (url.indexOf('man-skeleton.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png')
  if (url.indexOf('man-prehistoric.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png')
  if (url.indexOf('man-cyclist.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png')
  if (url.indexOf('man-soldier.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png')
  if (url.indexOf('man-hazard.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png')
  if (url.indexOf('man-business.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png')
  if (url.indexOf('man-farm.FBX') !== -1) return resolveStaticUrl('/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png')
  return item.textureUrl ? resolveStaticUrl(item.textureUrl) : null
}

function parseTintColor (hex) {
  if (hex == null) return null
  if (typeof hex === 'number') return hex
  const s = String(hex).replace('#', '')
  const n = parseInt(s, 16)
  return Number.isFinite(n) ? n : null
}

function isBoyAnimItem (item) {
  return (item.modelUrl || '').indexOf('男孩-7个模型动画') !== -1
}

function isGirlAnimItem (item) {
  return (item.modelUrl || '').indexOf('女生-7个模型动画') !== -1
}

function isAnimSkinnedItem (item) {
  return isBoyAnimItem(item) || isGirlAnimItem(item)
}

/** 各动作在 clip 上的定格进度，便于区分待机/点头/开心等姿态 */
const BOY_ANIM_HOLD_RATIO = {
  boy_daiji: 0,
  boy_diantou: 0.5,
  boy_kaixin: 0.25,
  boy_ku: 0.5,
  boy_shuijiao: 0.5,
  boy_yaotou: 0.5,
  boy_zhaoshou: 0.5
}

const GIRL_ANIM_HOLD_RATIO = {
  Connie_daiji: 0.5,
  Connie_diantou: 0.5,
  Connie_kaixin: 0.35,
  Connie_kuqi: 0.5,
  Connie_shuijiao: 0.5,
  Connie_yaotou: 0.5,
  Connie_huishou: 0.5
}

function resolveAnimHoldRatio (item) {
  if (!isAnimSkinnedItem(item)) return null
  const url = item.modelUrl || ''
  const table = isBoyAnimItem(item) ? BOY_ANIM_HOLD_RATIO : GIRL_ANIM_HOLD_RATIO
  for (const [key, ratio] of Object.entries(table)) {
    if (url.indexOf(key) !== -1) return ratio
  }
  return 0.5
}

/** 7 个动作 FBX 常只有骨骼动画，网格在单独的基础 FBX */
function resolveMeshSourceUrl (item) {
  if (isBoyAnimItem(item)) return BOY_MESH_FBX
  if (isGirlAnimItem(item)) return GIRL_MESH_FBX
  if (item.meshSourceUrl) return resolveStaticUrl(item.meshSourceUrl)
  return null
}

export function buildXinliSandEntriesByTab (tab) {
  return XINLI_SAND_MANIFEST.filter((item) => item.tab === tab).map((item) => ({
    label: item.label,
    emoji: item.emoji,
    modelKey: item.modelKey,
    modelUrl: resolveStaticUrl(item.modelUrl),
    thumbUrl: resolveStaticUrl(item.thumbUrl)
  }))
}

/** 心理沙盘独立分类：全部 心理沙盘模型 目录下的沙具 */
export function buildXinliSandEntries () {
  return XINLI_SAND_MANIFEST.map((item) => ({
    label: item.label,
    emoji: item.emoji,
    modelUrl: resolveStaticUrl(item.modelUrl),
    thumbUrl: resolveStaticUrl(item.thumbUrl)
  }))
}

/** 导出朝向与 manifest 不一致时，在此指定根节点欧拉角 [x,y,z]（弧度） */
const XINLI_MODEL_ROTATION = {
  /** 躺平导出：绕 X -90° 立起，正面朝相机（-Z） */
  '/static/models/心理沙盘模型/人物/唐僧/唐僧.FBX': [-Math.PI / 2, 0, 0],
  '/static/models/心理沙盘模型/人物/沙僧/沙僧.FBX': [-Math.PI / 2, 0, 0],
  '/static/models/心理沙盘模型/人物/孙悟空/悟空.FBX': [-Math.PI / 2, 0, 0],
  '/static/models/心理沙盘模型/人物/西游角色-共用fbx/牛魔王/牛魔王.FBX': [-Math.PI / 2, 0, 0],
  '/static/models/心理沙盘模型/人物/后羿/role_5518.fbx': [-Math.PI / 2, 0, 0]
}

export function buildXinliModelSpecs () {
  return XINLI_SAND_MANIFEST.map((item) => {
    const modelUrl = resolveStaticUrl(item.modelUrl)
    const modelParts = item.modelParts && item.modelParts.length
      ? item.modelParts.map((u) => resolveStaticUrl(u))
      : null
    const materialTextures = item.materialTextures && item.materialTextures.length
      ? item.materialTextures.map((u) => resolveStaticUrl(u))
      : null
    const meshTextures = item.meshTextures
      ? Object.fromEntries(
        Object.entries(item.meshTextures).map(([meshName, url]) => [meshName, resolveStaticUrl(url)])
      )
      : null
    const meshTextureCutout = item.meshTextureCutout && item.meshTextureCutout.length
      ? item.meshTextureCutout.slice()
      : null
    const boyAnim = isBoyAnimItem(item)
    const girlAnim = isGirlAnimItem(item)
    const animSkinned = boyAnim || girlAnim
    const meshColors = boyAnim
      ? { boy: 0xffcc99, ...(item.meshColors || {}) }
      : girlAnim
        ? { Connie: 0xffcc99, ...(item.meshColors || {}) }
        : (item.meshColors ? { ...item.meshColors } : null)
    return {
      key: item.modelKey || modelUrl,
      url: modelUrl,
      meshSourceUrl: resolveMeshSourceUrl(item),
      modelParts,
      modelPartOffsets: item.modelPartOffsets || null,
      meshKeep: item.meshKeep || null,
      meshRemove: item.meshRemove && item.meshRemove.length ? item.meshRemove.slice() : null,
      scaleMesh: item.scaleMesh || (boyAnim ? 'boy' : girlAnim ? 'Connie' : null),
      meshTextures,
      meshTextureCutout,
      meshColors,
      texture: materialTextures ? null : resolveXinliTexture(item),
      textureTintColor: parseTintColor(item.textureTintColor),
      meshLoadTexture: boyAnim ? BOY_MESH_TEX : girlAnim ? GIRL_ANIM_TEX : null,
      materialTextures,
      targetHeight: item.targetHeight,
      scaleBoost: item.scaleBoost,
      modelRotation: item.modelRotation || XINLI_MODEL_ROTATION[item.modelUrl] || null,
      flattenMeshBeforeRotate: !!item.flattenMeshBeforeRotate,
      humanCharacter: !!item.humanCharacter || animSkinned,
      flattenSkinnedMesh: animSkinned,
      animHoldRatio: resolveAnimHoldRatio(item),
      staticChildAttach: item.staticChildAttach || null,
      childMeshImport: item.childMeshImport || null,
      staticPose: isMainRigItem(item) || !!item.staticPose,
      cutoutTexture: !!item.cutoutTexture,
      alphaTextureUrl: item.alphaTextureUrl ? resolveStaticUrl(item.alphaTextureUrl) : null,
      defaultPropPitch: item.defaultPropPitch != null ? item.defaultPropPitch : null,
      propPitchMax: item.propPitchMax != null ? item.propPitchMax : null,
      groundLift: item.groundLift != null ? item.groundLift : 0
    }
  })
}

export function buildXinliTexturesMap () {
  const map = {}
  XINLI_SAND_MANIFEST.forEach((item) => {
    const tex = resolveXinliTexture(item)
    if (!tex) return
    const urls = item.modelParts && item.modelParts.length
      ? item.modelParts
      : [item.modelUrl]
    urls.forEach((u) => {
      map[resolveStaticUrl(u)] = tex
    })
    if (isBoyAnimItem(item)) {
      map[BOY_MESH_FBX] = BOY_MESH_TEX
    }
    if (isGirlAnimItem(item)) {
      map[GIRL_MESH_FBX] = GIRL_ANIM_TEX
    }
  })
  return map
}

export const XINLI_MODEL_URLS = XINLI_SAND_MANIFEST.map((item) => resolveStaticUrl(item.modelUrl))



// WEBPACK FOOTER //
// ./src/config/xinliSand.js